<div class="login_container">
  <div class="center">
    <h1>Welcome back.</h1>

    <form #loginForm="ngForm">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Email Address</mat-label>
          <input matInput placeholder=""
                 name="email"
                 required
                 type="email"
                 [(ngModel)]="email">
          <mat-error>
            Must be a valid email address!
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <div>
          <a routerLink="/forgot-password">Forgot password?</a>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput placeholder="password"
                 name="password"
                 [type]="hide ? 'password' : 'text'"
                 required
                 (keyup.enter)="login()"
                 [(ngModel)]="password">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div>
        <button mat-raised-button (click)="login()"
                [disabled]="!loginForm.valid" color="primary"
                class="smarticle_text_btn" cdkFocusInitial>Sign In</button>
      </div>
    </form>
  </div>
</div>
